// extracted by mini-css-extract-plugin
module.exports = {"container":"RequestsUserWrapper_container__3-tGZ","activeCursor":"RequestsUserWrapper_activeCursor__23Eq6","contentWrap":"RequestsUserWrapper_contentWrap__16YzI"};